// LOCAL
// const BASE_URL = "http://192.168.9.88:5444/node_api/";

// DEMO
// const BASE_URL = "https://ayushnatura.admin.iossmlm.com/node_api/";

// LIVE
const BASE_URL = "https://admin.ayushnatura.in/node_api/";


const DEFAULT_KEY = '14959'
const PAYPAL_CLIENT_ID = "ATtY3CotjXVye4iosAlVI4cuihnv8nNg_Y8R-dRLWPe_-GawRjLbtKqZxlSfP6XDOJlbvMR0I4ziL0a_"

export { BASE_URL, DEFAULT_KEY, PAYPAL_CLIENT_ID }
